import { CardGiftcard, Close } from "@mui/icons-material";
import { Box, Card, IconButton, Typography } from "@mui/joy";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { toast } from "react-toastify";

const HIDDEN_KEY = "giftCertificateBannerHidden";

export default function GiftCertificateBanner() {
  const intl = useIntl();
  const [hidden, setHidden] = useState(() => {
    try {
      return localStorage.getItem(HIDDEN_KEY) === "1";
    } catch {
      return false;
    }
  });

  if (hidden) {
    return null;
  }

  const hide = () => {
    try {
      localStorage.setItem(HIDDEN_KEY, "1");
    } catch {
      // The banner can still be hidden for this session when storage is unavailable.
    }
    setHidden(true);
    toast.info(intl.formatMessage({ defaultMessage: "Подарочный сертификат можно будет найти и приобрести в разделе «Настройки»" }), {
      autoClose: 4000,
      style: { background: "#e21f6b" },
    });
  };

  return (
    <Card
      variant="outlined"
      sx={{
        position: "relative",
        minHeight: 72,
        p: 0,
        overflow: "hidden",
        borderRadius: "lg",
        borderColor: "neutral.200",
        background: "linear-gradient(135deg, #fff5f8 0%, #f7f5ff 100%)",
      }}
    >
      <Box
        component="a"
        href="https://amani.by/gift-card"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          display: "flex",
          minHeight: 72,
          alignItems: "center",
          gap: 1.5,
          px: 1.5,
          pr: 7,
          color: "inherit",
          textDecoration: "none",
          WebkitTapHighlightColor: "transparent",
          "&:active": { backgroundColor: "rgba(217, 52, 126, 0.06)" },
          "&:focus-visible": {
            outline: "2px solid",
            outlineColor: "primary.500",
            outlineOffset: "-2px",
          },
        }}
      >
        <Box
          sx={{
            display: "grid",
            width: 40,
            height: 40,
            flex: "0 0 auto",
            placeItems: "center",
            borderRadius: "md",
            color: "#b92f6c",
            backgroundColor: "rgba(217, 52, 126, 0.1)",
          }}
        >
          <CardGiftcard />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography level="title-md">
            <FormattedMessage defaultMessage="Подарочный сертификат" />
          </Typography>
          <Typography level="body-sm" sx={{ mt: 0.25, color: "#a22c62" }}>
            <FormattedMessage defaultMessage="Подарить →" />
          </Typography>
        </Box>
      </Box>

      <IconButton
        size="sm"
        variant="plain"
        color="neutral"
        onClick={hide}
        sx={{
          position: "absolute",
          top: "50%",
          right: 6,
          transform: "translateY(-50%)",
          "--IconButton-size": "40px",
          borderRadius: "50%",
          color: "neutral.600",
          backgroundColor: "rgba(255, 255, 255, 0.72)",
          "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.92)" },
        }}
      >
        <Close fontSize="small" />
        <Box
          component="span"
          sx={{
            position: "absolute",
            width: "1px",
            height: "1px",
            p: 0,
            m: "-1px",
            overflow: "hidden",
            clip: "rect(0 0 0 0)",
            whiteSpace: "nowrap",
            border: 0,
          }}
        >
          <FormattedMessage defaultMessage="Закрыть" />
        </Box>
      </IconButton>
    </Card>
  );
}
